<template>
  <div>
    <b-card>
      <div class="row">
        <div class="col-lg-12">
          <h4>Emelő gép szerkesztése</h4>
        </div>
      </div>
    </b-card>
    <form-wizard
      ref="wizard"
      color="#3e74c7"
      :title="null"
      :subtitle="null"
      :enable-finish-button="true"
      layout="vertical"
      finish-button-text="Frissítés"
      next-button-text="Tovább"
      next-button-icon="fa fa-arrow-right"
      back-button-text="Vissza"
      class="wizard-vertical mb-3"
      tabindex="3"
      @on-complete="update"
    >

      <!-- account datails tab -->
      <tab-content title="Emelő gép adatai">
        <div class="row">
          <h5 class="col-lg-6 mb-0 pb-0">
            Emelő gép adatai
          </h5>
          <div class="col-lg-6 text-right">
            <button
              class="btn btn-primary"
              @click="update"
            >
              Frissítés
            </button>
          </div>
          <b-form-group
            label="Emelőgép megnevezése"
            label-for="name"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="name"
              v-model="name"
              type="text"
              placeholder="Emelőgép megnevezése"
            />
          </b-form-group>
          <b-form-group
            label="Gyártmány"
            label-for="brand"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="brand"
              v-model="brand"
              type="text"
              placeholder="Gyártmány"
            />
          </b-form-group>
          <b-form-group
            label="Típus"
            label-for="type"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="type"
              v-model="type"
              type="text"
              placeholder="Típus"
            />
          </b-form-group>
          <b-form-group
            label="Gyártási év"
            label-for="year_of_manufacture"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="year_of_manufacture"
              v-model="year_of_manufacture"
              type="number"
              placeholder="Gyártási év"
            />
          </b-form-group>
          <b-form-group
            label="Gyártási szám"
            label-for="manufacturing_number"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="manufacturing_number"
              v-model="manufacturing_number"
              type="text"
              placeholder="Gyártási szám"
            />
          </b-form-group>
          <b-form-group
            label="Aktuális üzemóra"
            label-for="current_hours"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="current_hours"
              v-model="current_hours"
              type="number"
              placeholder="Aktuális üzemóra"
            />
          </b-form-group>
          <b-form-group
            label="Szervíz intervallum"
            label-for="service_interval"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="service_interval"
              v-model="service_interval"
              type="number"
              placeholder="Szervíz intervallum"
            />
          </b-form-group>
        </div>

      </tab-content>
      <tab-content title="Szervíz">
        <div class="row mb-5">
          <h5 class="col-lg-6 mb-0 pb-0">
            Új szervíz hozzáadása
          </h5>
          <div class="col-lg-6 text-right">
            <button
              class="btn btn-primary"
              @click="update"
            >
              Frissítés
            </button>
          </div>
          <b-form-group
            label="Szervíz neve"
            label-for="service_service_name"
            class="col-md-2 mt-1"
          >
            <b-form-input
              id="service_service_name"
              v-model="service_service_name"
              type="text"
              placeholder="Szervíz neve"
            />
          </b-form-group>
          <b-form-group
            label="Számlaszám"
            label-for="service_billing_number"
            class="col-md-2 mt-1"
          >
            <b-form-input
              id="service_billing_number"
              v-model="service_billing_number"
              type="text"
              placeholder="Számlaszám"
            />
          </b-form-group>
          <b-form-group
            label="Elvégzés dátuma"
            label-for="service_date_of_completion"
            class="col-md-2 mt-1"
          >
            <b-form-input
              id="service_date_of_completion"
              v-model="service_date_of_completion"
              type="date"
              placeholder="Elvégzés dátuma"
            />
          </b-form-group>
          <b-form-group
            label="Üzemóra szervízkor"
            label-for="service_hours_at_the_time_of_service"
            class="col-md-3 mt-1"
          >
            <b-form-input
              id="service_hours_at_the_time_of_service"
              v-model="service_hours_at_the_time_of_service"
              type="number"
              placeholder="Üzemóra szervízkor"
            />
          </b-form-group>
          <b-form-group
            label="Szervíz intervallum"
            label-for="service_service_interval"
            class="col-md-3 mt-1"
          >
            <b-form-input
              id="service_service_interval"
              v-model="service_service_interval"
              type="text"
              placeholder="pl. 500 óra"
            />
          </b-form-group>
          <div class="col-lg-12 mt-2">
            <h6>Általános szolgáltatások</h6>
            <div class="d-flex flex-wrap gap-1">
              <b-button
                v-for="service in predefinedServices"
                :key="service"
                variant="outline-primary"
                size="sm"
                class="mr-1 mb-1"
                @click="addPredefinedService(service)"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="14"
                  class="mr-1"
                />
                {{ service }}
              </b-button>
            </div>
          </div>
          <div class="col-lg-6 mt-2">
            <h6>Szolgáltatás hozzáadása</h6>
            <b-form-input
              id="service_name_of_service_uniq"
              v-model="service_name_of_service_uniq"
              type="text"
              placeholder="Szolgáltatás neve"
            />
            <button
              class="btn btn-outline-primary w-100 text-center mt-2"
              @click="addToServicesUniq()"
            >
              <feather-icon
                icon="PlusIcon"
                size="16"
                class="mr-1"
              />
              Szolgáltatás hozzáadása
            </button>
          </div>
          <div class="col-lg-6 mt-2">
            <h6>Rögzített szolgáltatások</h6>
            <div
              class="service-badges"
              style="min-height: 80px;"
            >
              <span
                v-for="(service, index) in service_name_of_service"
                :key="index"
                style="cursor:pointer"
                class="badge badge-primary mr-1 mb-1"
                @click="removeService(index)"
              >
                {{ service }}
                <feather-icon
                  icon="XIcon"
                  size="14"
                  class="ml-1"
                />
              </span>
              <small
                v-if="service_name_of_service.length === 0"
                class="text-muted"
              >
                Még nincs szolgáltatás hozzáadva
              </small>
            </div>
          </div>
          <div class="col-md-12 mt-1">
            <button
              type="button"
              class="btn btn-primary"
              :disabled="service_name_of_service.length === 0"
              @click="addService"
            >
              <feather-icon
                icon="SaveIcon"
                size="16"
                class="mr-1"
              />
              Szervíz hozzáadása
            </button>
          </div>
          <div class="col-lg-12 mt-3">
            <h5>Meglévő szervízek</h5>
            <vue-good-table
              :columns="serviceColumns"
              :rows="services"
              :pagination-options="{
                enabled: true,
                perPage: 10
              }"
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span v-if="props.column.field === 'action'">
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    class="ml-1"
                    @click="removeServiceFull(props.row.id)"
                  >
                    Törlés
                  </b-button>
                </span>
                <span v-else-if="props.column.field === 'name_of_service'">
                  <div v-if="Array.isArray(props.row.name_of_service)">
                    <b-badge
                      v-for="(service, index) in props.row.name_of_service"
                      :key="index"
                      variant="primary"
                      class="mr-1 mb-1"
                      style="color: white !important;"
                    >
                      {{ service }}
                    </b-badge>
                  </div>
                  <span v-else>
                    {{ props.row.name_of_service }}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'service_interval'">
                  {{ formatServiceNextDue(props.row) }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BFormGroup,
  BFormInput,
  BCard,
  BButton,
  BBadge,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import axios from 'axios'

export default {
  components: {
    FormWizard,
    TabContent,
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
    VueGoodTable,
    BBadge,
    FeatherIcon,
  },
  data() {
    return {
      name: '',
      brand: '',
      type: '',
      year_of_manufacture: '',
      manufacturing_number: '',
      current_hours: '',
      service_interval: '',
      service_service_name: '',
      service_billing_number: '',
      services: [],
      service_date_of_completion: '',
      service_hours_at_the_time_of_service: '',
      service_name_of_service: [],
      service_name_of_service_uniq: '',
      service_service_interval: '',
      predefinedServices: [
        'Olajszűrő',
        'Olaj',
        'Levegőszűrő',
        'Pollenszűrő',
        'Üzemanyagszűrő',
        'Hidraulika olaj',
        'Hidraulika szűrő',
        'Váltóolaj',
      ],
      serviceColumns: [
        {
          label: 'Szervíz neve',
          field: 'service_name',
        },
        {
          label: 'Számlaszám',
          field: 'billing_number',
        },
        {
          label: 'Elvégzés dátuma',
          field: 'date_of_completion',
        },
        {
          label: 'Üzemóra szervízkor',
          field: 'hours_at_the_time_of_service',
        },
        {
          label: 'Szolgáltatások',
          field: 'name_of_service',
        },
        {
          label: 'Következő esedékes szervíz',
          field: 'service_interval',
        },
        {
          label: 'Műveletek',
          field: 'action',
        },
      ],
    }
  },
  watch: {
    current_hours(newValue) {
      if (!this.service_hours_at_the_time_of_service || this.service_hours_at_the_time_of_service === this.current_hours) {
        this.service_hours_at_the_time_of_service = newValue
      }
    },
    service_interval(newValue) {
      if (!this.service_service_interval || this.service_service_interval === this.service_interval) {
        this.service_service_interval = newValue
      }
    },
  },
  mounted() {
    this.getLiftingMachine()
    this.getService()
    this.$refs.wizard.nextTab()
    this.$refs.wizard.prevTab()
  },
  methods: {
    getService() {
      axios({
        method: 'get',
        url: `lifting-machine/${this.$route.params.id}/service/list`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.services = response.data
      })
    },
    addService() {
      axios({
        method: 'post',
        url: `lifting-machine/${this.$route.params.id}/service/create`,
        data: {
          service_name: this.service_service_name,
          billing_number: this.service_billing_number,
          date_of_completion: this.service_date_of_completion,
          hours_at_the_time_of_service: this.service_hours_at_the_time_of_service,
          name_of_service: this.service_name_of_service,
          service_interval: this.service_service_interval,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres hozzáadás!',
            text: 'A szervíz sikeresen hozzáadva.',
            variant: 'success',
          },
        })
        this.getService()
        this.service_service_name = ''
        this.service_billing_number = ''
        this.service_date_of_completion = ''
        this.service_hours_at_the_time_of_service = this.current_hours
        this.service_name_of_service = []
        this.service_name_of_service_uniq = ''
        this.service_service_interval = this.service_interval
      })
    },
    removeServiceFull(index) {
      axios({
        method: 'delete',
        url: `lifting-machine/service/delete/${index}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.getService()
      })
    },
    addToServicesUniq() {
      if (this.service_name_of_service_uniq.trim() !== '' && this.service_name_of_service.indexOf(this.service_name_of_service_uniq.trim()) === -1) {
        this.service_name_of_service.push(this.service_name_of_service_uniq.trim())
        this.service_name_of_service_uniq = ''
      }
    },
    addPredefinedService(serviceName) {
      if (this.service_name_of_service.indexOf(serviceName) === -1) {
        this.service_name_of_service.push(serviceName)
      }
    },
    removeService(index) {
      this.service_name_of_service.splice(index, 1)
    },
    formatServiceNextDue(service) {
      if (!service) {
        return 'Nincs adat'
      }

      const base = parseInt(service.hours_at_the_time_of_service, 10)
      const interval = parseInt(service.service_interval, 10)

      if (!Number.isNaN(base) && !Number.isNaN(interval)) {
        return `${base + interval} óra`
      }

      if (!Number.isNaN(interval)) {
        return `${interval} óra`
      }

      return 'Nincs adat'
    },
    getLiftingMachine() {
      axios({
        method: 'get',
        url: `lifting-machine/list/${this.$route.params.id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        this.name = res.data.name
        this.brand = res.data.brand
        this.type = res.data.type
        this.year_of_manufacture = res.data.year_of_manufacture
        this.manufacturing_number = res.data.manufacturing_number
        this.current_hours = res.data.current_hours
        this.service_interval = res.data.service_interval
        this.service_service_interval = res.data.service_interval
        this.service_hours_at_the_time_of_service = res.data.current_hours
      })
    },
    update() {
      axios({
        method: 'put',
        url: `lifting-machine/update/${this.$route.params.id}`,
        data: {
          name: this.name,
          brand: this.brand,
          type: this.type,
          year_of_manufacture: this.year_of_manufacture,
          manufacturing_number: this.manufacturing_number,
          current_hours: this.current_hours,
          service_interval: this.service_interval,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres frissítés!',
            text: 'Az emelő gép sikeresen frissítve.',
            variant: 'success',
          },
        })
        this.$router.push('/lifting-machines/list')
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'Az emelő gép frissítése sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
